module.exports = __webpack_public_path__ + "static/media/17.214e7c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/17.png
// module id = 1258
// module chunks = 0